import { render, staticRenderFns } from "./ListSortField.vue?vue&type=template&id=bfd1fbc8&"
import script from "./ListSortField.vue?vue&type=script&lang=js&"
export * from "./ListSortField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports